import Api from "../Api";

export default {
  getAvailabilities: (id, services) => Api.post(`/intervention/${id}/availabilities`, services),
  getAvailabilitiesDms: (id, services) => Api.post(`/intervention/${id}/availabilities?dms=true`, services)
}
